<template>
  <div>
    <app-header v-if="showHeader"></app-header>
    <div class="app-content">
      <app-container :fluid="fluid">
        <div v-if="navbackPath" class="app-content-navback">
          <a :href="navbackPath" class="link">
            <b-icon icon="chevron-left"></b-icon> {{ $t("back-to-overview") }}
          </a>
        </div>
        <div class="app-content-title">
          <h1><span v-html="title"></span> <app-super-admin-marker v-if="superAdminProtected" /></h1>
          <div v-if="subtitle" v-html="subtitle" class="app-content-subtitle text-muted"></div>
          <div v-if="!subtitle" class="app-content-subtitle text-muted">
            <slot name="subtitle"></slot>
          </div>
        </div>
        <div class="app-content-content">
          <div class="app-content-content-alert">
            <app-alert v-show="showAlert" :variant="alert.variant" :dismissible="true">
              {{ showAlert }}
              <div v-html="alert.msg"></div>
            </app-alert>
          </div>
          <div class="app-content-content-alert">
            <app-alert v-show="showAlertId" :variant="alertId.variant" :dismissible="true">
              <div v-html="alertId.msg"></div>
            </app-alert>
          </div>
          <slot></slot>
        </div>
      </app-container>
    </div>
  </div>
</template>

<script lang="ts">
import { Prop, Component } from "vue-property-decorator";
import AppHeader from "@/app/shared/components/app-header/app-header.vue";
import appContentEventBus from "@/app/shared/components/app-content/app-content-event-bus";
import { AppAlert as Alert, AppAlertEvents } from "@/app/shared/services/app-alert/app-alert";
import { AppContentEventService } from "@/app/shared/components/app-content/app-content-event-service";
import AppSuperAdminMarker from "@/app/shared/components/app-super-admin-marker/app-super-admin-marker.vue";
import { BaseAuthComponent } from "../base-auth-component/base-auth-component";
import AppAlert from "../app-alert/app-alert.vue";
import AppContainer from "../app-container/app-container.vue";

@Component({
  name: "app-content",
  components: {
    AppHeader,
    AppSuperAdminMarker,
    AppAlert,
    AppContainer,
  },
})
export default class AppContent extends BaseAuthComponent {
  @Prop({ required: true }) title: string | undefined;
  @Prop() subtitle: string | undefined;
  @Prop({ default: "" }) navbackPath!: string;
  @Prop({ default: true }) showHeader!: boolean;
  @Prop({ default: null }) eventId!: string | null;
  @Prop({ default: false }) superAdminProtected!: boolean;
  @Prop({ default: false }) fluid!: boolean;

  alert: Alert = { msg: "", variant: "info" };
  alertId: Alert = { msg: "", variant: "info" };
  showAlert = false;
  showAlertId = false;

  async created() {
    if (this.eventId) {
      AppContentEventService.on(this.eventId, AppAlertEvents.showAlert, (alert: AppAlert) => {
        this.alertId = alert;
        this.showAlertId = true;
      });
      AppContentEventService.on(this.eventId, AppAlertEvents.clearAlert, () => {
        this.showAlertId = false;
      });
    }

    appContentEventBus.onShowAlert((newAlert: Alert) => {
      this.alert = newAlert;
      this.showAlert = true;
    });
    appContentEventBus.onClearAlert(() => {
      this.showAlert = false;
    });

    this.setBrowserTitle(this.title);
  }
}
</script>

<style lang="scss">
@import "@/scss/_colors.scss";

.app-content {
  &-navback {
    margin-top: 30px;
  }
  &-title {
    margin: 30px 0;

    h1 {
      font-size: 3rem;
      margin-bottom: 10px;
    }
  }
  &-subtitle {
    font-size: 1.5rem;
  }
  &-content-alert {
    .alert {
      margin-bottom: 30px;
    }
  }
}
</style>
